<div class="xng-breadcrumb-bg">
    <div class="fixed-breadcrumb">
        <xng-breadcrumb [separator]="'•'">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <ng-container>{{ breadcrumb | translate }}</ng-container>
            </ng-container>
        </xng-breadcrumb>
    </div>
</div>
